/**
 * Imports here will be global to every final JS file for every site
 */

import Master from '../../assets/js/Master.js';
Master();

import RcmgAuth from '../../assets/js/RCMG_V2/RcmgAuth.js';
import RcmgModal from '../../assets/js/RCMG_V2/RcmgModal.js';

import lazysizes_rc_images from '../../assets/3rd_party/lazysizes/4.1.6/lazysizes_rc_images.js';